import { useState } from "react";
import { createPortal } from "react-dom";
import api from "@/api";
import { useI18n } from "@/i18n";
import { toast } from "sonner";
import { X, ShieldCheck, Lock } from "lucide-react";

export default function ElevateModal({ onClose }) {
  const { t } = useI18n();
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!secret.trim()) return;
    setBusy(true);
    try {
      const res = await api.staffElevate(secret.trim());
      localStorage.setItem("token", res.token);
      toast.success(t("elevOk"));
      window.location.href = "/app/azienda";
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("elevWrong"));
      setBusy(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[150] flex items-center justify-center bg-black/60 p-4" onClick={onClose} data-testid="elevate-overlay">
      <div className="bg-card text-foreground border border-border rounded-2xl shadow-2xl w-full max-w-sm p-6 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="elevate-modal">
        <div className="flex items-center justify-between mb-2">
          <div className="font-semibold text-lg flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-accent" /> {t("elevTitle")}
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-muted rounded-full" data-testid="elevate-close"><X className="w-4 h-4" /></button>
        </div>
        <p className="text-sm text-muted-foreground mb-4" data-testid="elevate-msg">{t("elevMsg")}</p>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="password"
              autoFocus
              className="field w-full pl-9"
              placeholder={t("elevPh")}
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              data-testid="elevate-secret"
            />
          </div>
          <button type="submit" disabled={busy || !secret.trim()} className="btn-primary w-full py-2.5 disabled:opacity-40" data-testid="elevate-submit">
            {busy ? "…" : t("elevBtn")}
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
}
